export { Collapsible, type CollapsibleProps } from "./Collapsible";
